import { getCookie, setCookie } from 'libs/utils/logic/operations/storageOperations';
import { checkLanguageExists } from 'libs/utils/logic/ui/languageLogic';
import { useContext, useEffect } from 'react';
import { CtxApp } from 'session/ctxApp';
import { LOCAL_STORAGE_LANGUAGE } from 'static/config/coreConfig';
import { Localization } from 'static/localization/localization';

export const useSetLanguage = () => {
    const ctxApp = useContext(CtxApp);

    useEffect(() => {
        const lang = getCookie(LOCAL_STORAGE_LANGUAGE);
        if (lang) {
            console.log('Cookie language', lang);
            Localization.setLanguage(lang);
            let locale = lang;
            if (locale === 'no') locale = 'nb';
            if (locale === 'nb') locale = 'nb';
            if (locale === 'nn') locale = 'nb';
            if (locale === 'se') locale = 'nb';
            // if (locale === 'jp') locale = 'ja';
            ctxApp.setLanguage(lang);
        } else {
            let language =
                (navigator.languages && navigator.languages[0]) ||
                navigator.language ||
                navigator['userLanguage'];
            //split code (cs-CZ)
            language = language.split('-')[0];
            Localization.setLanguage(language);
            let locale = language;
            if (locale === 'no') locale = 'nb';
            if (locale === 'nb') locale = 'nb';
            if (locale === 'nn') locale = 'nb';
            if (locale === 'se') locale = 'nb';
            // if (locale === 'jp') locale = 'ja';
            if (!checkLanguageExists(language)) {
                console.log('Fallback language end');
                Localization.setLanguage('en');
                setCookie(LOCAL_STORAGE_LANGUAGE, 'en');
                ctxApp.setLanguage('en');
            } else {
                console.log('Set language', language);
                setCookie(LOCAL_STORAGE_LANGUAGE, language);
                ctxApp.setLanguage(lang);
            }
        }
    }, []);
};
